// src/services/dashboardServices.js

const API_BASE = (
  process.env.REACT_APP_API_URL ||
  "https://api.psyassist.com.br"
).replace(/\/$/, "");

function createApiError(message, status, data) {
  const error = new Error(message);

  error.status = status;
  error.data = data;

  return error;
}

async function parseJsonResponse(response) {
  return await response
    .json()
    .catch(() => ({}));
}

function updateTokenFromResponse(
  response,
  currentToken
) {
  const newToken =
    response.headers.get("x-new-token");

  if (!newToken) {
    return currentToken;
  }

  const sessionToken =
    sessionStorage.getItem("psy_token");

  try {
    if (sessionToken) {
      sessionStorage.setItem(
        "psy_token",
        newToken
      );
    } else {
      localStorage.setItem(
        "psy_token",
        newToken
      );
    }
  } catch {
    // Mantém o token atual caso o storage esteja indisponível.
  }

  return newToken;
}

export async function fetchDashboard(
  arg1,
  arg2
) {
  let token = "";
  let range = "7d";
  let start = "";
  let end = "";
  let tz = "America/Sao_Paulo";

  if (
    typeof arg1 === "object" &&
    arg1 !== null
  ) {
    token = String(
      arg1.token || ""
    );

    range = String(
      arg1.range || "7d"
    );

    start = String(
      arg1.start || ""
    );

    end = String(
      arg1.end || ""
    );

    tz = String(
      arg1.tz ||
      "America/Sao_Paulo"
    );
  } else {
    /*
     * Compatibilidade com chamadas antigas:
     * fetchDashboard(id, token)
     *
     * O ID não é mais enviado. O backend usa o usuário do JWT.
     */
    token = String(arg2 || "");
  }

  if (!token) {
    throw new Error("Token ausente.");
  }

  const query =
    new URLSearchParams();

  if (start && end) {
    query.set("start", start);
    query.set("end", end);
  } else if (range) {
    query.set("range", range);
  }

  if (tz) {
    query.set("tz", tz);
  }

  const response = await fetch(
    `${API_BASE}/psy/dashboard?${query.toString()}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization:
          `Bearer ${token}`,
      },
    }
  );

  const data =
    await parseJsonResponse(response);

  if (!response.ok) {
    throw createApiError(
      data?.message ||
        `Erro ao carregar dashboard (HTTP ${response.status}).`,
      response.status,
      data
    );
  }

  updateTokenFromResponse(
    response,
    token
  );

  return data;
}

export async function fetchDashboardInsight({
  token,
  dashboard,
  range,
  start,
  end,
  tz,
} = {}) {
  if (!token) {
    throw new Error("Token ausente.");
  }

  /*
   * Mantém compatibilidade com o DashboardScreen atual.
   * O objeto dashboard não é enviado à API.
   * Usamos apenas o período para o backend montar seus próprios dados.
   */
  const requestRange =
    range ||
    dashboard?.meta?.range ||
    "7d";

  const requestStart =
    start ||
    (
      dashboard?.meta?.range === "custom"
        ? dashboard?.meta?.start
        : ""
    );

  const requestEnd =
    end ||
    (
      dashboard?.meta?.range === "custom"
        ? dashboard?.meta?.end
        : ""
    );

  const requestTimezone =
    tz ||
    dashboard?.meta?.tz ||
    "America/Sao_Paulo";

  const body = {
    range: requestRange,
    tz: requestTimezone,
  };

  if (requestStart && requestEnd) {
    body.start = String(requestStart)
      .slice(0, 10);

    body.end = String(requestEnd)
      .slice(0, 10);
  }

  const response = await fetch(
    `${API_BASE}/psy/insight/dashboard`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization:
          `Bearer ${token}`,
        "Content-Type":
          "application/json",
      },
      body: JSON.stringify(body),
    }
  );

  const data =
    await parseJsonResponse(response);

  if (!response.ok) {
    throw createApiError(
      data?.message ||
        `Erro ao gerar resumo inteligente (HTTP ${response.status}).`,
      response.status,
      data
    );
  }

  updateTokenFromResponse(
    response,
    token
  );

  return data;
}